<script>
import api from '@/command/api'
import TemplateHeaderTable from '../../../components/TemplateHeaderTable'
import moment from 'moment'

export default {
  name: 'advertising',
  data() {
    return {
      ...api.command.getState(),
    }
  },
  mounted() {
    api.command.getList.call(this, {
      url: '/farmPopUpAdvertisement/page',
      current: 1,
    })
  },
  methods: {
    getHeader() {
      return [
        {
          name: '活动名称',
          key: 'name',
          type: 'input',
        },
        {
          label: '',
          type: 'text',
          key: '',
        },
      ]
    },
    getColumns() {
      return [
        {
          dataIndex: 'id',
          title: 'ID',
          align: 'left',
          sorter: (a, b) => a.id - b.id,
        },
        {
          dataIndex: 'name',
          title: '活动名称',
          align: 'left',
          sorter: (a, b) => a.name.length - b.name.length,
        },
        {
          dataIndex: 'contentType',
          title: '类型',
          align: 'left',
          onExport: (text, records) => {
            return ['图片', '文本'][text]
          },
          customRender: function (text, records) {
            return ['图片', '文本'][text]
          },
        },
        {
          dataIndex: 'startTime',
          title: '活动时间',
          width: 100,
          align: 'left',
          onExport: (text, records) => {
            return text
              ? moment(text).format('YYYY/MM/DD HH:mm:ss') +
                  '——' +
                  moment(records.endTime).format('YYYY/MM/DD HH:mm:ss')
              : ''
          },
          customRender: function (text, records) {
            return text
              ? moment(text).format('YYYY/MM/DD HH:mm:ss') +
                  '——' +
                  moment(records.endTime).format('YYYY/MM/DD HH:mm:ss')
              : ''
          },
        },

        {
          dataIndex: 'upDown',
          title: '状态',
          type: 'badge',
          width: 100,
          filters: [
            {
              text: '下架',
              value: '1',
            },
            {
              text: '上架',
              value: '0',
            },
          ],
          onExport: (records) => {
            return ['上架', '下架'][records]
          },
          render(data) {
            return {
              showDot: true,
              name: data == 0 ? '上架' : '下架',
              color: data == 0 ? 'green' : 'red',
            }
          },
          filterMultiple: false,
        },
        {
          dataIndex: 'a9',
          title: '操作',
          type: 'buttonGroup',
          typeData: ({ records }) => {
            return [
              {
                name: records.upDown == 0 ? '下架' : '上架',
                onClick: () => {
                  api.command.editGET.call(this, {
                    url: `/farmPopUpAdvertisement/${records.upDown == 0 ? 'down' : 'up'}`,
                    params: {
                      id:records.id
                    },
                  })
                },
              },
              {
                name: '编辑',
                onClick: () => this.$router.push(`/marketingCenter/advertisingDetail?id=${records.id}`),
              },
              {
                name: '删除',
                type: 'pop',
                popTitle: '确认是否删除吗?',
                onClick: () =>
                  api.command.del.call(this, {
                    url: `/farmPopUpAdvertisement/deleteBatch`,
                    params: { idList: [records.id] },
                  }),
              },
            ]
          },
        },
      ]
    },
    getButton() {
      return [
        {
          name: '添加',
          type: 'primary',
          icon: 'plus',
          onClick: () => this.$router.push('/marketingCenter/advertisingDetail'),
        },
        {
          viewType: 'menu',
          name: '更多操作',
          isBatch: true,
          children: [
            {
              name: '批量删除',
              onClick: (data) => {
                let idList = data.map((e) => e.id)
                return api.command.del.call(this, {
                  url: '/farmPopUpAdvertisement/deleteBatch',
                  params: { idList },
                })
              },
            },
            // {
            //   name: '批量上架',
            //   onClick: (data) => {
            //     let idList = data.map((e) => e.id)
            //     return api.command.edit.call(this, {
            //       url: '/farmPopUpAdvertisement/upBatch',
            //       params: { idList },
            //     })
            //   },
            // },
            // {
            //   name: '批量下架',
            //   onClick: (data) => {
            //     let idList = data.map((e) => e.id)
            //     return api.command.edit.call(this, {
            //       url: '/farmPopUpAdvertisement/downBatch',
            //       params: { idList },
            //     })
            //   },
            // },
          ],
        },
      ]
    },
  },
  render() {
    return (
      <TemplateHeaderTable
        headerData={this.getHeader()}
        tableColumns={this.getColumns()}
        button={this.getButton()}
        records={this.records}
      />
    )
  },
}
</script>
